module.exports = __webpack_public_path__ + "static/img/hua1.79a7618.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hua1.png
// module id = /6Qa
// module chunks = 22